import { useSetRecoilState } from 'recoil';

import { guardianBlockReason } from '../atoms/guardianBlockReason';

export default function useSetGuardianBlockReason() {
  return useSetRecoilState(guardianBlockReason);
}
